package com.essntl.features.client.ui.allclients

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.client.ui.addeditclient.AddEditClientState
import com.essntl.features.client.ui.allclients.components.AllClientHeader
import com.essntl.features.client.ui.allclients.components.ClientListColumn
import com.essntl.uikit.components.utils.spacing

@Composable
fun AllClientsScreen(
    state: AllClientsState,
    onEvent: (AllClientsEvent) -> Unit,
    addEditClientState: AddEditClientState,
    onNavigation: (AllClientsNavigation) -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxSize(),
    ) {
        AllClientHeader(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
        )

        Spacer(modifier = Modifier.height(1.spacing))

        ClientListColumn(
            clientState = state.getAllClients,
            selectedClient = addEditClientState.getClient.data ?: ClientModel.empty,
            onEditClient = {
                onNavigation(AllClientsNavigation.EditClient(it))
            },
            onLoadMoreClient = {
                onEvent(AllClientsEvent.LoadClients())
            },
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f),
        )
    }
}